import React, { Component } from "react"
import { AlarmLevelTag, AlarmNameTag, AlarmStateTag } from "@/custom"

import { DarkModal } from "@/components/Modal";
import AlarmDevice from "./AlarmDevice"
import PlayerDevice from "./PlayerDevice"
import styles from "./index.module.less"
import { Divider } from "antd";
import AlarmStatus from "../handleAlarm/AlarmStatus";

class RealTimeAlarm extends Component {
    state = {
    }

    render() {
        const { visible, onClose, alarmInfo } = this.props;
        let modalProps = {
            title: '告警通知',
            width: '12rem',
            visible,
            maskClosable: false,
            onCancel: onClose,
            footer: null
        }
        if (!(alarmInfo && alarmInfo.id && alarmInfo.id.length > 0)) return ``;
        return <DarkModal centered {...modalProps} >
            <div className={styles.main}>
                <div className={styles.left}>
                    <div className={styles.dividerDiv}>
                        <Divider className={styles.dividerTitle} orientation="left">告警信息</Divider>
                    </div>
                    <AlarmStatus key={alarmInfo.id} alarmInfo={alarmInfo} />
                    <div className={styles.dividerDiv}>
                        <Divider className={styles.dividerTitle} orientation="left">告警设备</Divider>
                    </div>
                    <PlayerDevice key={alarmInfo.deviceId} deviceId={alarmInfo.deviceId} />
                </div>
                <div className={styles.right}>
                    {alarmInfo.linkageExecuteCameraDeviceIdList && alarmInfo.linkageExecuteCameraDeviceIdList.length > 0 ?
                        <PlayerDevice key={alarmInfo.linkageExecuteCameraDeviceIdList[0]} deviceId={alarmInfo.linkageExecuteCameraDeviceIdList[0]} />
                        : ``}
                </div>
            </div>
        </DarkModal>
    }

}

export default RealTimeAlarm